import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import CommentPost from 'flarum/forum/components/CommentPost';
import classList from 'flarum/common/utils/classList';
import PostControls from 'flarum/forum/utils/PostControls';
import VotesModal from './components/VotesModal';
import saveVote from './helpers/saveVote';
export default function () {
  extend(PostControls, 'moderationControls', function (items, post) {
    if (post.seeVoters()) {
      items.add('viewVotes', [m(Button, {
        icon: 'fas fa-thumbs-up',
        onclick: () => {
          app.modal.show(VotesModal, {
            post
          });
        }
      }, app.translator.trans('fof-gamification.forum.mod_item'))]);
    }
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;

    // Render nothing at all where voting does not apply — a disabled control
    // still tells the reader that voting exists here. The alternate layout
    // already does this; the two now behave the same way.
    if (!post.canSeeVotes()) return;

    // A deleted post keeps no vote controls. The alternate layout bails out on
    // hidden posts before it can swap this widget for its own, so adding it
    // here at all left the buttons on show behind the deleted-post overlay.
    if (post.isHidden()) return;
    const hasDownvoted = post.hasDownvoted();
    const hasUpvoted = post.hasUpvoted();
    const icon = app.forum.attribute('fof-gamification.iconName');
    const upVotesOnly = app.forum.attribute('fof-gamification.upVotesOnly');
    const canSeeVotes = post.canSeeVotes();

    // We set canVote to true for guest users so that they can access the login by clicking the button
    const canVote = !app.session.user || post.canVote();
    const onclick = (upvoted, downvoted) => saveVote(post, upvoted, downvoted, val => this.voteLoading = val);
    items.add('votes', m("div", {
      className: classList('CommentPost-votes', app.forum.attribute('fof-gamification.useAlternateLayout') && 'alternateLayout')
    }, Button.component({
      icon: this.voteLoading ? undefined : "fas fa-fw fa-".concat(icon, "-up"),
      className: classList('Post-vote Post-upvote', hasUpvoted && 'Post-vote--active'),
      loading: this.voteLoading,
      disabled: this.voteLoading || !canVote || !canSeeVotes,
      onclick: () => onclick(!hasUpvoted, false),
      'aria-label': app.translator.trans('fof-gamification.forum.post.upvote_button')
    }), m("label", {
      className: "Post-points"
    }, post.votes()), !upVotesOnly && Button.component({
      icon: this.voteLoading ? undefined : "fas fa-fw fa-".concat(icon, "-down"),
      className: classList('Post-vote Post-downvote', hasDownvoted && 'Post-vote--active'),
      loading: this.voteLoading,
      disabled: !canVote || !canSeeVotes,
      onclick: () => onclick(false, !hasDownvoted),
      'aria-label': app.translator.trans('fof-gamification.forum.post.downvote_button')
    })), 10);
  });
}